import React from 'react'
import { Container } from './styles'
import { CollapsedTimeline } from '../CollapsedTimeline'
import { HumanBody } from '~/components/patient/HumanBody'

export const HumanBodyTimeline = (): JSX.Element => {
  return (
    <Container>
      <CollapsedTimeline />
      <HumanBody />
    </Container>
  )
}
